function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import "./index.css";
import Message from "./components/message/Message";
import { BrowserRouter } from "react-router-dom";
import { setApiClients, setStandardHooks } from "./api/config/config";
import { jsx as _jsx } from "react/jsx-runtime";
const MessageCenter = props => {
  return /*#__PURE__*/_jsx(BrowserRouter, {
    children: /*#__PURE__*/_jsx(MessageCenterMain, _objectSpread({}, props))
  });
};
const MessageCenterMain = _ref => {
  let {
    adapters,
    hooks,
    currentEmployee,
    constants,
    callbacks,
    source,
    options
  } = _ref;
  const {
    twilioClient,
    coreApi
  } = adapters;
  // Avoid initial render until adapters are available.
  if (!twilioClient || !coreApi) return null;
  setApiClients(adapters);
  setStandardHooks(hooks);
  return /*#__PURE__*/_jsx("main", {
    children: /*#__PURE__*/_jsx(Message, {
      currentEmployeeId: currentEmployee,
      constants: constants,
      toast: callbacks.toast,
      messageCenterLogger: callbacks.messageCenterLogger,
      TEXT_AREA_ID: constants.TEXT_AREA_ID,
      source: source,
      options: options
    })
  });
};
MessageCenter.defaultProps = {
  source: '',
  currentEmployee: '',
  adapters: {
    apiMessagingService: null,
    coreApi: {},
    twilioClient: {}
  },
  hooks: {},
  callbacks: {
    toast: null,
    messageCenterLogger: null
  },
  constants: {
    TEXT_AREA_ID: ''
  },
  components: PropTypes.any,
  options: {
    headerLinksEnabled: true,
    archiveEnabled: false
  }
};
MessageCenter.propTypes = {
  source: PropTypes.string,
  currentEmployee: PropTypes.string.isRequired,
  adapters: PropTypes.shape({
    apiMessagingService: PropTypes.func.isRequired,
    coreApi: PropTypes.object.isRequired,
    twilioClient: PropTypes.object.isRequired
  }),
  hooks: PropTypes.object,
  callbacks: PropTypes.shape({
    toast: PropTypes.shape({
      success: PropTypes.func,
      error: PropTypes.func,
      warn: PropTypes.func
    }).isRequired,
    messageCenterLogger: PropTypes.func.isRequired
  }),
  constants: PropTypes.shape({
    TEXT_AREA_ID: PropTypes.string.isRequired
  }),
  components: PropTypes.any,
  options: PropTypes.shape({
    headerLinksEnabled: PropTypes.bool,
    archiveEnabled: PropTypes.bool
  })
};
export default MessageCenter;
//# sourceMappingURL=MessageCenter.js.map